{
  "familyId": "GET-KOMMA-WAARDE",
  "questions": [
    {
      "id": "GET-KOMMA-WAARDE-001",
      "familyId": "GET-KOMMA-WAARDE",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "skill": "kommagetallen",
      "subSkill": "komma_decimale_waarde",
      "questionType": "number_sequence",
      "question": "Welk getal komt hierna in de reeks?",
      "context": "0,1 - 0,2 - 0,3 - ?",
      "options": ["0,4", "0,5", "1,0", "0,03"],
      "correctAnswer": 0,
      "data": {
        "sequence": [0.1, 0.2, 0.3, null],
        "missingIndex": 3,
        "correctValue": 0.4,
        "step": 0.1
      },
      "conceptId": "decimal_sequence_tenths",
      "variantIndex": 1,
      "group": 6,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 0,
            "max": 1,
            "value": 0.3,
            "step": 0.1,
            "label": "Getallenlijn met tienden: 0,1 → 0,2 → 0,3 → ?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "number_line",
          "showWhen": "wrong",
          "data": {
            "min": 0,
            "max": 1,
            "value": 0.4,
            "step": 0.1,
            "label": "Elke stap is +0,1. Na 0,3 komt 0,4"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: zoek het patroon. Van 0,1 naar 0,2 is +0,1. Van 0,2 naar 0,3 is ook +0,1. Stap 2: elke stap is +0,1 (één tiende). Stap 3: 0,3 + 0,1 = 0,4. Het volgende getal is 0,4.",
        "distractorExplanations": {
          "0": "Goed! Elke stap is +0,1, dus 0,3 + 0,1 = 0,4.",
          "1": "0,5 is twee stappen verder (0,3 + 0,2). Je hebt de stapgrootte verdubbeld. De stap is +0,1, niet +0,2.",
          "2": "1,0 is veel te groot. De stap in deze reeks is +0,1 (één tiende), niet +0,7. Na 0,3 komt 0,4.",
          "3": "0,03 is kleiner dan 0,1. Je hebt de komma één plek verschoven. De reeks gaat in stappen van tienden (0,1), niet honderdsten (0,01)."
        }
      }
    },
    {
      "id": "GET-KOMMA-WAARDE-002",
      "familyId": "GET-KOMMA-WAARDE",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "skill": "kommagetallen",
      "subSkill": "komma_decimale_waarde",
      "questionType": "number_sequence",
      "question": "Vul het ontbrekende getal in:",
      "context": "0,25 - 0,50 - ? - 1,00",
      "options": ["0,75", "0,60", "0,80", "0,25"],
      "correctAnswer": 0,
      "data": {
        "sequence": [0.25, 0.5, null, 1],
        "missingIndex": 2,
        "correctValue": 0.75,
        "step": 0.25
      },
      "conceptId": "decimal_sequence_quarters",
      "variantIndex": 2,
      "group": 6,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 0,
            "max": 1,
            "value": 0.5,
            "step": 0.25,
            "label": "Getallenlijn met kwarten: 0,25 → 0,50 → ? → 1,00"
          }
        }
      ],
      "supportAids": [
        {
          "type": "number_line",
          "showWhen": "wrong",
          "data": {
            "min": 0,
            "max": 1,
            "value": 0.75,
            "step": 0.25,
            "label": "Elke stap is +0,25 (een kwart). Na 0,50 komt 0,75"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: zoek het patroon. Van 0,25 naar 0,50 is +0,25 (een kwart). Stap 2: van 0,50 naar 1,00 is ook +0,50 — maar dat zijn twee stappen. Stap 3: het ontbrekende getal is 0,50 + 0,25 = 0,75. Controleer: 0,75 + 0,25 = 1,00. ✓",
        "distractorExplanations": {
          "0": "Goed! Elke stap is +0,25 (een kwart), dus 0,50 + 0,25 = 0,75.",
          "1": "0,60 klopt niet. De stap in deze reeks is +0,25, niet +0,10. Van 0,50 + 0,25 = 0,75, niet 0,60.",
          "2": "0,80 klopt niet. Je hebt misschien +0,30 gerekend. Maar de stap is +0,25 (een kwart). Controleer: 0,75 + 0,25 = 1,00.",
          "3": "0,25 is het eerste getal in de reeks, niet het ontbrekende. Het ontbrekende getal ligt tussen 0,50 en 1,00: dat is 0,75."
        }
      }
    },
    {
      "id": "GET-KOMMA-WAARDE-003",
      "familyId": "GET-KOMMA-WAARDE",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "skill": "kommagetallen",
      "subSkill": "komma_decimale_waarde",
      "questionType": "ordering",
      "question": "Zet deze getallen op volgorde van klein naar groot:",
      "options": [
        "0,3 - 0,7 - 1,2 - 1,5",
        "1,5 - 1,2 - 0,7 - 0,3",
        "0,7 - 0,3 - 1,2 - 1,5",
        "0,3 - 1,2 - 0,7 - 1,5"
      ],
      "correctAnswer": 0,
      "data": {
        "items": ["0,3", "0,7", "1,2", "1,5"],
        "correctOrder": [0, 1, 2, 3],
        "direction": "ascending"
      },
      "conceptId": "order_decimals_ascending",
      "variantIndex": 1,
      "group": 6,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 0,
            "max": 2,
            "value": 0.3,
            "step": 0.5,
            "label": "Getallenlijn: vergelijk 0,3 — 0,7 — 1,2 — 1,5"
          }
        }
      ],
      "supportAids": [
        {
          "type": "number_line",
          "showWhen": "wrong",
          "data": {
            "min": 0,
            "max": 2,
            "value": 1.5,
            "step": 0.5,
            "label": "Op de getallenlijn: hoe verder naar rechts, hoe groter. Volgorde: 0,3 → 0,7 → 1,2 → 1,5"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: vergelijk de getallen voor de komma. 0,3 en 0,7 hebben 0 voor de komma; 1,2 en 1,5 hebben 1 voor de komma. Stap 2: getallen met 0 voor de komma zijn kleiner dan getallen met 1. Stap 3: binnen de groep met 0: 0,3 < 0,7. Binnen de groep met 1: 1,2 < 1,5. Volgorde: 0,3 - 0,7 - 1,2 - 1,5.",
        "distractorExplanations": {
          "0": "Goed! 0,3 < 0,7 < 1,2 < 1,5 — van klein naar groot.",
          "1": "Dit is de volgorde van groot naar klein (aflopend), niet van klein naar groot. Draai de volgorde om.",
          "2": "0,7 en 0,3 staan omgewisseld. Op de getallenlijn staat 0,3 links van 0,7, dus 0,3 < 0,7. De juiste volgorde begint met 0,3.",
          "3": "0,7 en 1,2 staan omgewisseld. 0,7 heeft 0 voor de komma, 1,2 heeft 1 voor de komma. Dus 0,7 < 1,2. Volgorde: 0,3 - 0,7 - 1,2 - 1,5."
        }
      }
    },
    {
      "id": "GET-KOMMA-WAARDE-004",
      "familyId": "GET-KOMMA-WAARDE",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "skill": "kommagetallen",
      "subSkill": "komma_decimale_waarde",
      "questionType": "ordering",
      "question": "Zet deze getallen op volgorde van groot naar klein:",
      "options": [
        "2,5 - 1,8 - 0,9 - 0,3",
        "0,3 - 0,9 - 1,8 - 2,5",
        "2,5 - 0,9 - 1,8 - 0,3",
        "1,8 - 2,5 - 0,9 - 0,3"
      ],
      "correctAnswer": 0,
      "data": {
        "items": ["2,5", "1,8", "0,9", "0,3"],
        "correctOrder": [0, 1, 2, 3],
        "direction": "descending"
      },
      "conceptId": "order_decimals_descending",
      "variantIndex": 2,
      "group": 6,
      "stimulusAids": [
        {
          "type": "number_line",
          "data": {
            "min": 0,
            "max": 3,
            "value": 2.5,
            "step": 0.5,
            "label": "Getallenlijn: vergelijk 0,3 — 0,9 — 1,8 — 2,5"
          }
        }
      ],
      "supportAids": [
        {
          "type": "number_line",
          "showWhen": "wrong",
          "data": {
            "min": 0,
            "max": 3,
            "value": 0.3,
            "step": 0.5,
            "label": "Op de getallenlijn: hoe verder naar links, hoe kleiner. Van groot naar klein: 2,5 → 1,8 → 0,9 → 0,3"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: vergelijk de getallen voor de komma: 2, 1, 0, 0. Stap 2: van groot naar klein op het gehele deel: 2,5 eerst (2 voor komma), dan 1,8 (1 voor komma). Stap 3: 0,9 en 0,3 hebben beide 0 voor de komma — vergelijk tienden: 9 > 3, dus 0,9 vóór 0,3. Volgorde: 2,5 - 1,8 - 0,9 - 0,3.",
        "distractorExplanations": {
          "0": "Goed! 2,5 > 1,8 > 0,9 > 0,3 — van groot naar klein.",
          "1": "Dit is de volgorde van klein naar groot (oplopend). De vraag vraagt van groot naar klein. Begin bij het grootste getal: 2,5.",
          "2": "1,8 en 0,9 staan omgewisseld. 1,8 heeft 1 voor de komma, 0,9 heeft 0 voor de komma. Dus 1,8 > 0,9. Volgorde: 2,5 - 1,8 - 0,9 - 0,3.",
          "3": "2,5 en 1,8 staan omgewisseld. 2,5 heeft 2 voor de komma, 1,8 heeft 1 voor de komma. Dus 2,5 > 1,8. Begin met het grootste getal: 2,5."
        }
      }
    },
    {
      "id": "GET-KOMMA-WAARDE-005",
      "familyId": "GET-KOMMA-WAARDE",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "skill": "kommagetallen",
      "subSkill": "komma_decimale_waarde",
      "questionType": "fill_in",
      "question": "Vul de ontbrekende waarde in: 3,__ = 3 hele en 5 tienden",
      "options": ["5", "50", "05", "0,5"],
      "correctAnswer": 0,
      "data": {
        "template": "3,__",
        "correctValue": "5",
        "acceptedAnswers": ["5", "50"],
        "hint": "5 tienden schrijf je als 0,5 of als ,5 achter de komma",
        "placeholder": "Vul het cijfer in...",
        "caseSensitive": false
      },
      "conceptId": "fill_decimal_tenths",
      "variantIndex": 1,
      "group": 6,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "Tienden achter de komma",
            "content": "Het getal 3,5 bestaat uit: 3 hele + 5 tienden. Het cijfer op de tiendenplek (eerste plek achter de komma) is 5."
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "5 tienden = 0,5",
            "content": "5 tienden schrijf je als 0,5. In het getal 3,5 staat de 5 op de tiendenplek (eerste plek achter de komma). Schrijf: 3,5"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: 5 tienden = $\\frac{5}{10}$ = 0,5. Stap 2: het getal heeft 3 hele en 5 tienden. Stap 3: schrijf de tienden achter de komma: 3,5. Het cijfer achter de komma op de tiendenplek is 5.",
        "distractorExplanations": {
          "0": "Goed! 5 tienden schrijf je als het cijfer 5 op de tiendenplek: 3,5.",
          "1": "50 zou 50 tienden zijn = 5 hele. Dan zou het getal 3 + 5 = 8 zijn, niet 3,5. De tiendenplek heeft maar één cijfer: 5.",
          "2": "05 is hetzelfde als 5, maar met een onnodige nul. De tiendenplek heeft het cijfer 5: schrijf 3,5.",
          "3": "0,5 is de decimale waarde van 5 tienden, maar de vraag vraagt het cijfer op de tiendenplek. Dat cijfer is 5 (niet 0,5)."
        }
      }
    },
    {
      "id": "GET-KOMMA-WAARDE-006",
      "familyId": "GET-KOMMA-WAARDE",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "skill": "kommagetallen",
      "subSkill": "komma_decimale_waarde",
      "questionType": "multiple_choice",
      "question": "Welk kommagetal hoort bij $\\frac{3}{4}$?",
      "options": ["0,75", "0,34", "0,50", "3,4"],
      "correctAnswer": 0,
      "conceptId": "decimal_fraction_conversion",
      "variantIndex": 1,
      "group": 6,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "3/4 = ?",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "3/4 = 0,75 (drie kwart = 75 honderdste)",
            "visualType": "bar",
            "showEaten": false,
            "decimalEquivalent": "0,75"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: $\\frac{3}{4}$ betekent 3 ÷ 4. Stap 2: 3 ÷ 4 = 0,75. Of: $\\frac{3}{4}$ = $\\frac{75}{100}$ = 0,75. Drie kwart is 75 honderdsten.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4}$ = 3 ÷ 4 = 0,75.",
          "1": "Je hebt het getal boven de streep (3) en het getal onder de streep (4) naast elkaar gezet. Maar $\\frac{3}{4}$ betekent 3 ÷ 4 = 0,75, niet 0,34.",
          "2": "0,50 = $\\frac{1}{2}$ (een half). Maar $\\frac{3}{4}$ is drie kwart — dat is groter dan een half. 3 ÷ 4 = 0,75.",
          "3": "3,4 is een getal groter dan 3. Maar $\\frac{3}{4}$ is kleiner dan 1, want het getal boven de streep (3) is kleiner dan het getal onder de streep (4). Het antwoord is 0,75."
        }
      }
    }
  ]
}
